export const PRODUCT_AGGREGATED = 'productAggregated';

export const PRODUCT_AGGREGATED_ACTIONS_NAME = {
  searchProductAggregated: `${PRODUCT_AGGREGATED}/searchProductAggregated`,
} as const;

export const PRODUCT_AGGREGATED_MUTATIONS_NAME = {
  setProductAggregated: `${PRODUCT_AGGREGATED}/setProductAggregated`,
} as const;

export const PRODUCT_AGGREGATED_GETTERS_NAME = {
  getProductAggregated: `${PRODUCT_AGGREGATED}/getProductAggregated`,
} as const;
